<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a
            class="linkstyle"
            href="https://www.chanchao.com.tw/ExhibitorServiceTW/en"
            >Exhibition List</a
          >
          <span>/</span> <em name="Exhibition">{{ ExhibitionName }}</em
          ><span>/</span>Basic Information
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div class="MbDevice">
      <div class="homeLeft mt-5">
        <div class="UserAccount ml-1">
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
        <hr />
        <p class="my-3">&nbsp;</p>

        <div class="expoLogo">
          <div class="imgCorp squareThumb">
            <img :src="ExhLogo" width="100%" />
          </div>
        </div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition">{{ ExhibitionName }}</p>
          <p>{{ Exhdate }}</p>
          <p>{{ eExhVenue }}</p>
        </div>

        <p class="clear"></p>
      </div>
    </div>

    <div class="articleEn">
      <div class="PcDevice">
        <div class="contentBoxStatus">
          <Dashboard></Dashboard>
        </div>
        <div class="my-3"></div>
      </div>

      <div class="MbDevice container contentBoxStatus">
        <Dashboard></Dashboard>
      </div>

      <div class="contentBox">
        <h1>Basic Information</h1>
        <p class="my-3">&nbsp;</p>

        <form
          enctype="multipart/form-data"
          id="form"
          @submit.prevent="updateEnLogo"
        >
          <input type="hidden" name="RegNo" />

          <div class="proLeft PcDevice">
            <label class="inputFile">
              <div class="mb-3 ImgHoverStyle pointer">
                <img :src="modelSrc" class="img-fluid" />
              </div>
              <p class="my-3">&nbsp;</p>
              <span name="showName" class="nowrap"></span>
              <input
                type="file"
                name="ProImg"
                accept=".jpg,.jpeg,.webp"
                @change="uploadNewImgPC($event)"
              />
              <p class="divider"></p>
              <div class="d-flex justify-content-around">
                <div>
                  <p class="align_c">
                    <span class="btnStyle btnGray">Select Image</span>
                  </p>
                </div>
                <div v-if="modelSrc !== OImgSrc">
                  <p class="align_c">
                    <span class="btnStyle btnRed" @click.prevent="resetImg"
                      >Reset Image
                    </span>
                  </p>
                </div>
              </div>
            </label>
            <div class="uploadAlert">
              <p class="italic">File Size：Maximum 3MB</p>
              <p class="italic">File Format：JPG、WEBP</p>
              <p class="italic">Pixel Size：Minimum 500 x 500 Pixel</p>
            </div>
          </div>

          <div class="proLeft MbDevice">
            <label class="inputFile pointer">
              <div class="mb-3"><img :src="modelSrc" class="img-fluid" /></div>
              <p class="my-3">&nbsp;</p>
              <span name="showName" class="nowrap"></span>
              <input
                type="file"
                name="ProImg"
                accept=".jpg,.jpeg,.webp"
                @change="uploadNewImgMb($event)"
              />
              <p class="divider"></p>

              <div class="d-flex justify-content-around">
                <div>
                  <p class="align_c">
                    <span class="btnStyle btnGray">Select</span>
                  </p>
                </div>
                <div v-if="modelSrc !== OImgSrc">
                  <p class="align_c">
                    <span class="btnStyle btnRed" @click.prevent="resetImg"
                      >Reset
                    </span>
                  </p>
                </div>
              </div>
            </label>
            <div class="uploadAlert">
              <p class="italic">File Size：Maximum 3MB</p>
              <p class="italic">File Format：JPG、WEBP</p>
              <p class="italic">Pixel Size：Minimum 500 x 500 Pixel</p>
            </div>
          </div>

          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <div class="alert">
              <p>
                If you need to modify the company name, telephone, fax,<a
                  href="//www.chanchao.com.tw/en/contact.asp"
                  target="_blank"
                >
                  please contact the organizer</a
                >.
              </p>
              <p class="mt-1">
                The following information will be shown on the official website
                > Exhibitor List.
              </p>
            </div>
            <p class="my-3">&nbsp;</p>
            <p class="formTitle">Company Name</p>
            <p name="Directory_ComName">{{ profileList.Directory_ComName }}</p>
            <p name="Directory_eComName">
              {{ profileList.Directory_eComName }}
            </p>
            <p class="my-3">&nbsp;</p>
            <div class="left">
              <p class="formTitle">Exhibition Area</p>
              <p name="ExhibArea">{{ profileList.eExhibArea }}</p>
            </div>
            <div class="right">
              <p class="formTitle">Booth No.</p>
              <p name="BoothNo">{{ profileList.BoothNo }}</p>
            </div>
            <p class="clear"></p>

            <p class="my-3">&nbsp;</p>
            <div class="left">
              <p class="formTitle">Used Sqm</p>
              <p name="ExhibArea">{{ profileList.booth_sqm }}</p>
            </div>
            <div class="right">
              <p class="formTitle">Stand Type</p>
              <p name="BoothNo">
                <span v-if="profileList.booth_type == 'A'"> Raw Space </span>
                <span v-else-if="profileList.booth_type == 'B'">
                  Shell Scheme
                </span>
                <span v-else-if="profileList.booth_type == 'C'">
                  Shell Scheme + Raw Space
                </span>
              </p>
            </div>
            <p class="clear"></p>
            <p class="my-3">&nbsp;</p>
            <p class="formTitle">Brand Name</p>
            <div class="langTip">
              <input
                type="text"
                name="eBrandName"
                class="maxText textStyle"
                v-model="profileList.eBrandName"
                maxlength="150"
              />
              <span>EN</span>
            </div>
            <p class="divider"></p>

            <div v-if="LocalExh">
              <div class="langTip">
                <input
                  type="text"
                  name="BrandName"
                  class="maxText textStyle"
                  maxlength="100"
                  v-model="profileList.BrandName"
                />
                <span>中</span>
              </div>
            </div>

            <p class="my-3">&nbsp;</p>
            <div class="left">
              <p class="formTitle">Contact</p>
              <p class="bold" name="RegContact"></p>
              <p>
                <span class="formContent"> Name : </span
                ><span name="RegTel">{{ profileList.RegContact }}</span>
              </p>
              <p>
                <span class="formContent">Tel :</span>
                <span name="RegTel">{{ profileList.RegTel }}</span>
              </p>
              <p v-if="profileList.RegFax">
                <span class="formContent">Fax :</span>
                <span name="RegFax">{{ profileList.RegFax }}</span>
              </p>
              <p>
                <span class="formContent">Mob :</span>
                <span name="RegMobile">{{ profileList.RegMobile }}</span>
              </p>
              <!-- <p class="divider"></p>
                            <div><span class="formContent">Email :</span> <span class="displayBlock"
                                    name='RegEmail'></span>
                                <div class="mt-1">
                                    <ul v-for="item in emailListArray">
                                        <li> {{item}}</li>
                                    </ul>
                                </div>
                            </div> -->
            </div>

            <p class="clear"></p>
          </div>
          <!-- right end -->
          <p class="clear"></p>
          <p class="my-3">&nbsp;</p>
          <div class="align_c">
            <div class="PcDevice text-center">
              <input
                type="Submit"
                value="Submit"
                class="btn btn-lg btn-primary"
              />
            </div>
            <div class="MbDevice text-center">
              <input type="Submit" value="Submit" class="btn btn-primary" />
            </div>
          </div>
        </form>

        <!-- 桌機板裁切工具 Modal  -->
        <div id="cropImagePop" class="modal fade" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header d-flex justify-content-between">
                <h3 class="modal-title" style="font-size: 25px">
                  <img
                    class="mb-2 mr-2"
                    src="@/assets/images/cropImg.png"
                    width="30px"
                  />
                  Edit Profile Image
                </h3>
                <div
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-8">
                    <div class="CropBoxStyle">
                      <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :output-size="option.size"
                        :output-type="option.outputType"
                        :info="true"
                        :full="option.full"
                        :fixed="fixed"
                        :can-move="option.canMove"
                        :can-move-box="option.canMoveBox"
                        :fixed-box="option.fixedBox"
                        :original="option.original"
                        :auto-crop="option.autoCrop"
                        :auto-crop-width="option.autoCropWidth"
                        :auto-crop-height="option.autoCropHeight"
                        :center-box="option.centerBox"
                        :high="option.high"
                        :max-img-size="option.max"
                        :fixed-number="fixedNumber"
                        :enlarge="option.enlarge"
                        :infoTrue="option.infoTrue"
                        :mode="option.mode"
                        @real-time="realTime"
                      >
                      </vue-cropper>
                    </div>

                    <div class="d-flex justify-content-between mt-3 mx-3">
                      <div>
                        <button @click="rotateLeft" class="btn btn-info">
                          Rotate Left
                        </button>
                        <button @click="rotateRight" class="btn btn-info ml-2">
                          Rotate Right
                        </button>
                        <button
                          @click="changeScale(1)"
                          class="btn btn-info ml-2"
                        >
                          +
                        </button>
                        <button
                          @click="changeScale(-1)"
                          class="btn btn-info ml-2"
                        >
                          -
                        </button>
                      </div>

                      <div>
                        <button
                          @click="refreshCrop"
                          class="btn btn-outline-info ml-5"
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div :style="previewStyle1" class="cropViewFrame">
                      <div :style="previews.div">
                        <img :src="previews.url" :style="previews.img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="modal-footer">
                <div>
                  <button
                    type="button"
                    id="cropImageBtn"
                    class="btn btn-lg btn-primary mr-2"
                    @click="OutputPC()"
                  >
                    Crop
                  </button>
                  <button
                    type="button"
                    class="btn btn-lg btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 行動版裁切工具 Modal  -->
        <div
          class="modal fade"
          id="cropperMb"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            class="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-body">
                <p>
                  &middot; Automatically resize your image into square image.
                </p>
                <p>
                  &middot; If you need to crop or edit your image, please use
                  the computer to upload your image.
                </p>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  id="cropperMb"
                  class="btn btn-sm btn-primary"
                  @click="OutputMb()"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showImg" class="CropBoxStyle">
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :fixed="fixed"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
            :max-img-size="option.max"
            :fixed-number="fixedNumber"
            :enlarge="option.enlarge"
            :infoTrue="option.infoTrue"
            :mode="option.mode"
          >
          </vue-cropper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import Dashboard from "@/components/Dashboard_en.vue";

export default {
  components: {
    Dashboard,
  },
  metaInfo() {
    return {
      title: `Basic Information - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      profileList: {},
      emailListArray: [],
      previews: {},
      previewStyle1: {},
      modelSrc: "",
      OImgSrc: "",
      showImg: false,
      lang: "en",
      LocalExh: true,

      option: {
        img: "", // 裁剪图片的地址V
        max: 9999, //限制图片最大宽度和高度
        enlarge: 1,
        mode: "contain",

        centerBox: false, // 截图框是否被限制在图片里面
        canMove: true, //上传图片是否可以移动
        infoTrue: true,

        fixedBox: true, // 固定截图框大小 不允许改变
        canMoveBox: false, // 截图框能否拖动
        autoCrop: true, // 是否默认生成截图框
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 500,

        full: true, //是否输出原图比例的截图，X匯出等比例(長型就匯長型)
        high: true, //是否按照设备的dpr 输出等比例图片，X匯出等比例(長型就匯長型)
        original: true, // 上传图片按照原始比例渲染

        size: 1, //裁剪生成图片的质量V
        outputType: "webp", // 裁剪生成图片的格式V
      },

      fixed: true, // 是否开启截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例

      logoImg: "",
      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      linkSource: "",
      OnlineExpolayoutStatus: "",
      PressReleaseStatus: "",
      VideoStatus: "",
      ProductStatus: "",
      BasicinformationStatus: "",

      //判斷儀表板是否有線上展
      HasOnlineExpo: "",
      openOnlineExpo: "",
      showOnlineStatus: false,

      initialLogo: "",
    };
  },
  methods: {
    resetImg() {
      const vm = this;
      vm.modelSrc = vm.OImgSrc;
    },

    updateEnLogo() {
      //須測試英文版是否可以偵測到來源從線上展覽設定頁來

      const vm = this;
      const url = `/apiExhibitors/Profile/`;

      // console.log(info)

      if (vm.modelSrc == "/images/default.jpg") {
        alert("Must provide image, please check again! ");
      } else {
        if (vm.modelSrc == vm.initialLogo) {
          let info2 = {
            CSRF: vm.CSRF_Token,
            Logo: "",
            BrandName: vm.profileList.BrandName,
            eBrandName: vm.profileList.eBrandName,
            RegNo: vm.RegNo,
          };

          axios.post(url, info2).then(function (response) {
            if (vm.linkSource !== "onlineExpo") {
              if (response.data.Code == 200) {
                alert("Successfully changed your basic information! ");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/profile?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("System is busy, please try again later.");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/profile?no=${vm.RegNo}`;
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`;
              } else if (response.data.Code == 253) {
                alert("Exhibit Brand is empty! ");
              } else if (response.data.Code == 254) {
                alert("Image upload failed! ");
              }
            } else {
              if (response.data.Code == 200) {
                alert(
                  "Successfully changed your basic information! Will redirect you to the Online Expo settings page.",
                );
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/onlineExpo?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("System is busy, please try again later.");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/profile?no=${vm.RegNo}`;
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`;
              } else if (response.data.Code == 253) {
                alert("Exhibit Brand is empty!");
              } else if (response.data.Code == 254) {
                alert("Image upload failed! ");
              }
            }
          });
        } else {
          let info2 = {
            CSRF: vm.CSRF_Token,
            Logo: vm.modelSrc,
            BrandName: vm.profileList.BrandName,
            eBrandName: vm.profileList.eBrandName,
            RegNo: vm.RegNo,
          };

          axios.post(url, info2).then(function (response) {
            if (vm.linkSource !== "onlineExpo") {
              if (response.data.Code == 200) {
                alert("Successfully changed your basic information! ");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/profile?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("System is busy, please try again later.");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/profile?no=${vm.RegNo}`;
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`;
              } else if (response.data.Code == 253) {
                alert("Exhibit Brand is empty! ");
              } else if (response.data.Code == 254) {
                alert("Image upload failed! ");
              }
            } else {
              if (response.data.Code == 200) {
                alert(
                  "Successfully changed your basic information! Will redirect you to the Online Expo settings page.",
                );
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/onlineExpo?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("System is busy, please try again later.");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/profile?no=${vm.RegNo}`;
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`;
              } else if (response.data.Code == 253) {
                alert("Exhibit Brand is empty!");
              } else if (response.data.Code == 254) {
                alert("Image upload failed! ");
              }
            }
          });
        }
      }
    },

    uploadNewImgPC(e) {
      const vm = this;
      // alert(vm.option.img)

      if (!/\.(jpg|JPG|jpeg|JPEG|webp|WEBP)$/.test(e.target.value)) {
        if (vm.lang == "tw") {
          alert("上傳檔案類型必須是 JPG, WebP！");
          return false;
        } else {
          alert("Upload file must be in JPG or WebP! ");
          return false;
        }
      } else {
        let file = e.target.files[0];

        let reader = new FileReader();

        reader.onload = (e) => {
          const isLt5M = e.total / 1024 / 1024 < 3;

          if (isLt5M) {
            $("#cropImagePop").modal("show");

            $("#cropImagePop").on("shown.bs.modal", function () {
              vm.option.img = window.URL.createObjectURL(
                new Blob([e.target.result]),
              );
              // alert(vm.option.img)
            });
          } else {
            if (vm.lang == "tw") {
              alert("上傳圖片大小請勿超過 3MB！");
            } else {
              alert("Maximum file size : 3MB");
            }
          }
        };

        reader.readAsArrayBuffer(file);
        e.target.value = "";
      }
    },

    uploadNewImgMb(e) {
      const vm = this;

      //上传图片
      // this.option.img
      let file = e.target.files[0];
      if (!/\.(jpg|JPG|jpeg|JPEG|webp|WEBP)$/.test(e.target.value)) {
        if (vm.lang == "tw") {
          alert("上傳檔案類型必須是 JPG, WebP！");
          return false;
        } else {
          alert("Upload file must be in JPG or WebP! ");
          return false;
        }
      }
      let reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        if (isLt5M) {
          this.option.img = window.URL.createObjectURL(
            new Blob([e.target.result]),
          );
          vm.showImg = true;
          $("#cropperMb").modal("show");
        } else {
          if (vm.lang == "tw") {
            alert("上傳圖片大小請勿超過 3MB！");
          } else {
            alert("Maximum file size : 3MB");
          }
        }
      };
      e.target.value = "";
    },

    OutputPC() {
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;

        $("#cropImagePop").modal("hide");

        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.option.img = "/";
        });
      });
    },

    OutputMb() {
      // 输出
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
      });

      $("#cropperMb").modal("hide");
      vm.showImg = false;
    },

    realTime(data) {
      var previews = data;
      var h = 0.5;
      var w = 0.2;

      this.previewStyle1 = {
        width: previews.w + "px",
        height: previews.h + "px",
        overflow: "hidden",
        margin: "0",
        zoom: h,
      };
      this.previews = data;
    },

    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },

    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },

    refreshCrop() {
      this.$refs.cropper.refresh();
    },
  },

  created() {
    const vm = this;

    //取得語系

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let nowPage = location.href;
    vm.RegNo = nowPage.split("no=")[1];

    let hasPagenum = new URL(nowPage);
    vm.linkSource = hasPagenum.searchParams.get("source");

    //取得當前時間
    let theDate = new Date();
    vm.date = `${theDate.getFullYear()}/${
      theDate.getMonth() + 1
    }/${theDate.getDate()}`;

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        vm.profileList = response.data.Data;

        //取得是否填寫狀態盤的值

        vm.OnlineExpolayoutStatus = response.data.Data.OnlineExpolayoutStatus;
        vm.PressReleaseStatus = response.data.Data.PressReleaseStatus;
        vm.VideoStatus = response.data.Data.VideoStatus;
        vm.ProductStatus = response.data.Data.ProductStatus;
        vm.BasicinformationStatus = response.data.Data.BasicinformationStatus;

        if (response.data.Data.Logo) {
          vm.modelSrc = `//www.chanchao.com.tw/exhibitorservicefiles/logo/${response.data.Data.Logo}`;
          vm.OImgSrc = `//www.chanchao.com.tw/exhibitorservicefiles/logo/${response.data.Data.Logo}`;
          vm.initialLogo = `//www.chanchao.com.tw/exhibitorservicefiles/logo/${response.data.Data.Logo}`;
        } else {
          vm.modelSrc = `/images/default.jpg`;
          vm.OImgSrc = `/images/default.jpg`;
          vm.initialLogo = `/images/default.jpg`;
        }

        vm.HasOnlineExpo = response.data.Data.Virtual;

        //取得是否開啟線上展權限
        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
          )
          .then((response) => {
            // console.log(response.data)

            vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
            vm.ExhBegin = response.data.Data.ExhBegin;
            vm.ExhEnd = response.data.Data.ExhEnd;
            vm.ExhVenue = response.data.Data.ExhVenue;
            vm.eExhVenue = response.data.Data.eExhVenue;

            if (ExpoLocation === "T" || ExpoLocation === null) {
              vm.LocalExh = true;
            } else {
              vm.LocalExh = false;
            }
          });
      });
  },
};
</script>

<style lang="scss">
.uncomplete {
  background-image: url("../../assets/images/tickGray.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.complete {
  background-image: url("../../assets/images/tick.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.btn {
  border-radius: 5px;
}

.cropViewFrame {
  border: 1px solid rgb(210, 228, 238);
}

.formContent {
  font-weight: 550;
  font-size: 15px;
}

@media screen and (min-width: 331px) and (max-width: 576px) {
  .modal-content {
    width: 65%;
  }
}

@media screen and (max-width: 330px) {
  .modal-content {
    width: 60%;
  }
}

.modal-xl {
  max-width: 940px;
}
</style>
